(() => {
  'use strict';

  function initStickyBuyNow(scope = document) {
    const roots = scope.matches?.('[data-nawah-product]')
      ? [scope]
      : [...scope.querySelectorAll?.('[data-nawah-product]') || []];

    roots.forEach((root) => {
      const sticky = root.querySelector('[data-nawah-sticky]');
      const stickyAdd = root.querySelector('[data-nawah-sticky-submit]');
      const mainBuyNow = root.querySelector('[data-nawah-buy-now]');

      if (!sticky || !stickyAdd || !mainBuyNow || sticky.querySelector('[data-nawah-sticky-buy-now]')) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'nawah-sticky-atc__buy-now';
      button.setAttribute('data-nawah-sticky-buy-now', 'true');
      button.textContent = mainBuyNow.querySelector('[data-nawah-buy-now-label]')?.textContent?.trim() || 'Buy now';
      stickyAdd.insertAdjacentElement('afterend', button);
      sticky.classList.add('nawah-sticky-atc--dual-action');

      const syncAvailability = () => {
        button.disabled = Boolean(stickyAdd.disabled || mainBuyNow.disabled);
      };

      new MutationObserver(syncAvailability).observe(stickyAdd, {
        attributes: true,
        attributeFilter: ['disabled'],
      });
      new MutationObserver(syncAvailability).observe(mainBuyNow, {
        attributes: true,
        attributeFilter: ['disabled'],
      });
      syncAvailability();

      button.addEventListener('click', () => {
        if (button.disabled) return;

        const stickyQuantity = root.querySelector('[data-nawah-sticky-qty]');
        const quantityInput = root.querySelector('input[name="quantity"]');
        if (stickyQuantity && quantityInput) {
          quantityInput.value = stickyQuantity.value;
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        mainBuyNow.click();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initStickyBuyNow(), { once: true });
  } else {
    initStickyBuyNow();
  }

  document.addEventListener('shopify:section:load', (event) => initStickyBuyNow(event.target));
})();
